import { Injectable } from "@angular/core";

/**
 * A service that handles downloading files.
 */
@Injectable({
  providedIn: 'root'
})
export class FileService {

  /**
   * Downloads a file as a blob.
   * @param {Blob} file - the file to download
   * @param {string} filename - the name of the file to download
   * @returns None
   */
  downloadBlob(file: Blob, filename: string) {
    let downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(file);
    downloadLink.setAttribute('download', filename);
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }


  /**
   * Downloads a file from data.
   * @param {string} file - the data to download
   * @param {string} filename - the name of the file to download
   * @returns None
   */
  downloadFile(file: string, filename: string) {
    var binary_string = window.atob(file);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    var byteArray = new Uint8Array(bytes.buffer);
    let blob = new Blob([byteArray], { type: 'application/octet-stream' });
    this.downloadBlob(blob, filename)
  }

}
